import RefundAndCancellation from "../components/Refund&Cancellation/RefundAndCancellation";

export default {
  name: "RefundAndCancellation",
  component: RefundAndCancellation,
  url: "/refund&cancellation",
  exact: true,
  requireAuth: true
};